<template>
    <div id="returnPostage">
        <van-cell-group class="form-input">
            <van-field
                v-model.trim="userInfo.oldIccid"
                required
                label="手机号："
                placeholder="请输入申请的手机号"
                
            />
        </van-cell-group>

        <div class="formLine">
            <van-button type="primary" size="small" @click.prevent="returnPostage()">查询快递信息</van-button> 
        </div> 

        <!-- <div id="questionDetail">
            <div class="info" v-for="item in questionInfo"   :key="item.id">            
                <div class="line">
                 <label>申请状态：</label>
                 <div><span>{{ item.disposeStateName }}</span></div>
            </div>
            <div class="line">
                <label>申请时间：</label>
                <div><span>{{ item.createTime }}</span></div>
            </div>
            <div class="line">
                <label>快递单号：</label>
                <div class="moreInfo">{{ item.disposeRemark }}</div>
            </div>        
        </div> -->


        <div class="recordPanel">
                <div v-if="questionInfo.length > 0">
                    <div v-for="item in questionInfo"   :key="item.id" class="records">
                        <ul class="rechargeInfo">
                            <li>
                                <label>快递单号：</label>
                                <span>{{ item.disposeRemark }}</span>
                            </li>
                            <li>
                                <label>申请状态：</label>
                                <span>{{ item.disposeStateName }}</span>
                            </li>
                            <li>
                                <label>申请时间：</label>
                                <span >{{ item.createTime }}</span>
                            </li>
                        </ul>     
                    </div>
                    <div class="tips">---我是有底线的---</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
        </div> 
    </div>
</template>
<script>
import {wxRequest} from '@/api/user.js' 

export default {
    data(){
        return {
            userInfo: {
                oldIccid: ''
            },
            questionInfo:[],
        }        
    },
    created() {
      
    },
    methods: {              
        returnPostage(){
            if(this.userInfo.oldIccid==''){
                this.$dialog.alert({title:'提示', message: '请先输入查询手机号'});
                return;
            }
            var lets={
                takePhone:this.userInfo.oldIccid
            }
            wxRequest("applyChangeSim/select/sim", lets, "post").then(res => {
                if(res.data.code==200){
                    this.questionInfo=res.data.data
                }else{
                this.$dialog.alert({title:'提示', message: res.data.message});
                }
            })
        }
    },

    mounted(){

    },
}
</script>

<style>

#returnPostage .van-field__body{
    height: 100%;
}

#returnPostage .van-button--small {
    height: 35px;
    width: 96%;
    letter-spacing: 1px;
}
</style>

<style lang="less">
    #returnPostage{
        .formLine{
            display: flex;
            margin-top: 10px;
            justify-content: center;
            .van-button{
                width: 300px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                color: #fff;
                font-size: 15px;
                background: #0091ff;
                border-radius: 10px;
                margin: 5px auto 30px auto;
                border: 1px solid #f7f8fa;
            }
        }

        .recordPanel {
            min-height: 100%;
            background: #f2f2f2;
            .records {
                margin-bottom: 12px;
                background: #fff;
            }
            h4 {
                display: flex;
                justify-content: space-between;
                padding: 0 4%;
                line-height: 34px;
            .money {
                color: red;
            }
            }
            ul {
                padding: 0 4%;
                border-top: 1px solid #f0f0f0;
                border-bottom: 1px solid #f0f0f0;
                li {
                    line-height: 28px;
                }
            }
            .btnOuter {
                padding: 0 4%;
                line-height: 34px;
                text-align: right;
            }
            .tips {
                color: #a0a0a0;
                text-align: center;
                line-height: 28px;
            }
            .nodata {
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;  
                img {
                    width: 14%;
                    margin: 10px;
                }   
                span{
                    margin-bottom: 10px;
                }   
            }
        }
    }
    

</style>